import React, { type FC } from 'react';

import { useFormattedDatetime } from '@/hooks/useFormattedDatetime';

import TextCell from './TextCell';

type FormattedDatetimeCellProps = {
  value: string | Date | null | undefined;
  variant?: 'date' | 'datetime';
};

const FormattedDatetimeCell: FC<FormattedDatetimeCellProps> = ({ value, variant = 'datetime' }) => {
  const { formatDate, formatDatetime } = useFormattedDatetime();
  const formatted = variant === 'datetime' ? formatDatetime(value) : formatDate(value);

  return <TextCell>{formatted}</TextCell>;
};

export default FormattedDatetimeCell;
